@if (href()) {
  @if (internalLink()) {
    <a [id]="innerId()" [aria-label]="ariaLabel()" class="button {{ styleClass() }} icon-{{ iconPosition() }}" [class.loading]="loading()" [routerLink]="href()" [queryParams]="queryParams()" (click)="triggerAction($event)">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </a>
  } @else {
    <a [id]="innerId()" [aria-label]="ariaLabel()" class="button {{ styleClass() }} icon-{{ iconPosition() }}" [class.loading]="loading()" [href]="href()" [rel]="rel()" [target]="target()" (click)="triggerAction($event)">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </a>
  }
} @else {
  <button [id]="innerId()" [aria-label]="ariaLabel()" class="button {{ styleClass() }} icon-{{ iconPosition() }}" [class.loading]="loading()" [disabled]="disabled()" (click)="triggerAction($event)">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </button>
}
<ng-template #content>
  <span class="button-content" [style.visibility]="loading() ? 'hidden' : 'visible'">
    @if (icon()) {
      <span class="icon" style="mask-image: url('/icons/{{ icon() }}.svg'); -webkit-mask-image: url('/icons/{{ icon() }}.svg')" [class.with-label]="label()"></span>
    }
    @if (label()) {
      {{ label() }}
    }
  </span>
  @if (loading()) {
    <span class="loading-icon-wrapper">
      <svg class="loading-icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 8C16 9.47538 15.592 10.922 14.8211 12.18C14.0502 13.438 12.9465 14.4582 11.6319 15.1281C10.3174 15.7979 8.84316 16.0911 7.37233 15.9753C5.9015 15.8596 4.49132 15.3393 3.29772 14.4721C2.10411 13.6049 1.17357 12.4245 0.608964 11.0615C0.0443609 9.6984 -0.132307 8.20574 0.0984932 6.74853C0.329293 5.29131 0.95857 3.9263 1.91675 2.80442C2.87493 1.68253 4.12469 0.847465 5.52786 0.391548L6.2695 2.67408C5.28729 2.99323 4.41245 3.57777 3.74173 4.36309C3.071 5.14841 2.63051 6.10392 2.46895 7.12397C2.30739 8.14402 2.43105 9.18888 2.82627 10.143C3.2215 11.0972 3.87288 11.9235 4.7084 12.5305C5.54393 13.1375 6.53105 13.5017 7.56063 13.5827C8.59021 13.6638 9.62215 13.4585 10.5423 12.9896C11.4625 12.5208 12.2352 11.8066 12.7748 10.926C13.3144 10.0454 13.6 9.03277 13.6 8H16Z" fill="currentColor"/>
      </svg>
    </span>
  }
</ng-template>
